import {
  createMatterLitigationDateTypeV1,
  deleteMatterLitigationDateTypeV1,
  updateMatterLitigationDateTypeV1,
} from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";
import { type APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import toast from "react-hot-toast";

export const useCreateMatterLitigationDateType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (
      data: Parameters<typeof createMatterLitigationDateTypeV1>[0],
    ) => createMatterLitigationDateTypeV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error creating matter litigation date type");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matterSettings],
      });
    },
    onSuccess: () => {
      toast.success("Matter litigation date type created successfully");
    },
  });
};

export const useUpdateMatterLitigationDateType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (
      data: Parameters<typeof updateMatterLitigationDateTypeV1>[0],
    ) => updateMatterLitigationDateTypeV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error updating matter litigation date type");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matterSettings],
      });
    },
    onSuccess: () => {
      toast.success("Matter litigation date type updated successfully");
    },
  });
};

export const useDeleteMatterLitigationDateType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (
      data: Parameters<typeof deleteMatterLitigationDateTypeV1>[0],
    ) => deleteMatterLitigationDateTypeV1(data),
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error deleting matter litigation date type");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matterSettings],
      });
    },
    onSuccess: () => {
      toast.success("Matter litigation date type deleted successfully");
    },
  });
};
